import { useFormContext, UseFormReturn } from "react-hook-form";

import { AiInterviewerFormValues } from "./types";

export const useAiInterviewerFormContext =
  (): UseFormReturn<AiInterviewerFormValues> => {
    return useFormContext<AiInterviewerFormValues>();
  };
